// extracted by mini-css-extract-plugin
export default {"container":"Show_container__RxJsS","loader":"Show_loader__TDUOZ","backLink":"Show_backLink__Kjo06"};